<template>
  <div class="baseVue">
    <!--<img class="headerImg" src="http://www.worldelite.net.cn/upfile/146854563818533200.jpg" alt />-->
    <div class="baseContent" v-if="parentEle.barType !=6">
      <div class="baseContent-left">
        <div class="baseContent-left-title">
          <span style="font-size:20px;" v-if="langes==0">{{parentEle.menuObj.barName}}</span>
          <!-- <a v-if="langes==0" href="#">{{parentEle.menuObj.barEngName}}</a> -->
          <span style="font-size:20px;" v-if="langes==1">{{parentEle.menuObj.barEngName}}</span>
        </div>
        <div class="baseContent-left-list">
          <ul>
            <li
              v-for="(item,index) in list"
              :key="index"
              :class="{activeName:currentIndex == index}"
              @click="listClick(item,index)" >
              <a v-if="langes ==0" href="#">{{item[parentEle.title] | ellipsis}}</a>
              <a v-else href="#">{{item[parentEle.title+'En'] | ellipsis}}</a>
            </li>
          </ul>
        </div>
      </div>
      <!-- 内容是富文本的 -->
      <base-content :currentObj="currentObj" v-if="parentEle.barType == 2"></base-content>
      <!-- 内容时新闻类型且带分页的 -->
      <base-news :currentObj="currentObj" v-if="parentEle.barType==3"></base-news>
      <!-- 内容时图片类型且带分页的 -->
      <base-img :currentObj="currentObj" v-if="parentEle.barType==4"></base-img>
      <!-- 内容时地图类型 -->
      <base-map :currentObj="currentObj" v-if="parentEle.barType==5"></base-map>
    </div>
    <!-- 不带左侧按钮的  值展示右边图片分页 -->
    <div v-else>
      <base-product></base-product>
    </div>
  </div>
</template>
<script>
import baseContent from '@/components/baseContent.vue';
import baseNews from '@/components/baseNews.vue';
import baseImg from '@/components/baseImg.vue';
import baseProduct from '@/components/baseProduct.vue';
import baseMap from '@/components/baseMap.vue';
export default {
  components: { baseContent, baseNews, baseImg, baseMap, baseProduct },
  props:{
    title: {
      type: Object,
      default: () => { }
    },
     content: {
      type: Object,
      default: () => { }
    }

  },
  data() {
    return {
      list: [],
      currentIndex: 0,
      currentObj: {},
      langes: 0
    }
  },
  inject: ['parentEle'],
  mounted() {
    this.getLeftMenu();
    this.langes = sessionStorage.getItem('watchStorage');
    window.addEventListener('setItem', () => {
      this.langes = sessionStorage.getItem('watchStorage');
    })
  },
  watch: {
    'parentEle.urls'() {
        this.getLeftMenu();
    },
   

  },
 filters:{
     ellipsis: function(value) {
         if (!value) return "";
           if (value.length > 7) {
                    return value.slice(0, 7) + "...";
            }
                return value;
       }
  },  
  methods: {
    listClick(item, index) {
      let pathList = JSON.parse(sessionStorage.getItem('pathList'));
      pathList[1] = item;
      sessionStorage.setItem('pathList', JSON.stringify(pathList));
      this.currentObj = item;
      this.currentIndex = index;
    },
    getLeftMenu() {
      this.$api.get(this.parentEle.urls).then(res => {
        this.list = res.response;
        this.list.length && this.listClick(this.list[0], 0)
      })
    }
  }
}
</script>
<style scoped lang="less">
.baseVue {
  height: 100%;
  background-color: #f1f1f1;
  // width: 982px;
  // margin: auto;
  .headerImg {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .baseContent {
    height: calc(~"100% - 180px");
    overflow: hidden;
    &-left {
      width: 235px;
      float: left;
      &-title {
        text-align: left;
        height: 61px;
        //background: url("http://www.worldelite.net.cn/data/templates/cn/img/leftbg.jpg");
        background-color:white;
        box-shadow: 0px 0px 10px 5px #cccc;
        span {
          color: #333;
          font-size: 16px;
          padding-top: 15px;
          padding-left: 16px;
          display: inline-block;
        }
        a {
          font-size: 12px;
          color: #78c0e5;
          padding-left: 6px;
        }
      }
      &-list {
        min-height: calc(~"100vh - 260px");
        background-color:white;
        box-shadow: 0px 0px 10px 5px #cccc;
        ul {
          padding-top: 10px;
          padding-left: 16px;
          padding-bottom: 20px;
          li {
            width: 137px;
            height: 27px;
            font-size: 16px;
            text-align: left;
            line-height: 27px;
            padding-top: 8px;
            padding-bottom: 8px;
            // background: url("http://www.worldelite.net.cn/data/templates/cn/img/leftherebg01.jpg")
            //   26px center no-repeat;
            margin-bottom: 2px;
            border-bottom: 1px solid #e5e9e8;
            padding-left: 66px;
            a {
              color: #6c7771;
            }
          }
          .activeName {
            //background: url("http://www.worldelite.net.cn/data/templates/cn/img/leftherebg.jpg")
            //  left center no-repeat;
            background-color: #015DB7;
            a {
              color: #fff;
            }
          }
        }
      }
    }
  }
}
</style>